import { useAppDispatch } from '@/app/hooks';
import { openSusDetailDrawer } from '@/features/drawer/drawerSlice';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type Props = {
  /** Id du service d'urgence à consulter ; ses données sont chargées à l'ouverture du panneau. */
  id: number;
};

const SusViewButton = ({ id }: Props) => {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();

  return (
    <Tooltip label={t('admin.sus.view')} withArrow>
      <ActionIcon
        variant="subtle"
        aria-label={t('admin.sus.view')}
        onClick={() => dispatch(openSusDetailDrawer(t('admin.sus.view'), id))}
      >
        <IconEye size={16} stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
};

export default SusViewButton;
